export class InvalidHeaderError extends Error {
  constructor(msg: string) {
    super(msg);
    this.name = 'InvalidHeaderError';
  }
}
